/**
 * Initializes a Slick slider on elements with the class `.page-slider`.
 *
 * Slider Configuration:
 * - Dots: Enabled for navigation.
 * - Arrows: Disabled.
 * - Autoplay: Enabled with a speed of 3000ms.
 * - Slides to Show: 3 slides visible at a time.
 * - Slides to Scroll: 1 slide per scroll.
 * - Center Mode: Enabled to center the active slide.
 * - Center Padding: 50px padding around the centered slide.
 * - Initial Slide: Starts at the second slide (index 1).
 * - Infinite Loop: Enabled for continuous scrolling.
 *
 * Responsive Breakpoints:
 * - At 1024px and below:
 *   - Slides to Show: 2 slides visible.
 *   - Slides to Scroll: 1 slide per scroll.
 *   - Center Padding: Reduced to 30px for smaller screens.
 * - At 600px and below:
 *   - Slides to Show: 1 slide visible.
 *   - Slides to Scroll: 1 slide per scroll.
 *   - Center Padding: Reduced to 20px for mobile devices.
 */

// Initialize the Slick slider
// This slider is used on block-page-links.liquid
$('.page-slider').slick({
  dots: true,
  dotsClass: 'slick-dots !tw-hidden [&:has(:nth-child(2))]:!tw-flex',
  arrows: false,
  autoplay: false,
  variableWidth: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: 2560,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
})

// This slider is used on block-testimonials.liquid
$('.testimonial-slider').slick({
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  fade: true,
  appendDots: '.testimonial-slider-dots',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        verticalSwiping: true,
      },
    },
  ],
})

$('.upsell-slider').slick({
  dots: true,
  arrows: false,
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  fade: false,
  appendDots: '.upsell-slider-dots',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
})

// Resizing function for the USP Slides. Adjusts everything so that the height across all slides is the same.
function normalizeUspSlideHeights() {
  const $slides = $('.usp-slider .usp-block')

  let maxHeight = 0

  $slides.css('height', 'auto')

  $slides.each(function () {
    const height = $(this).outerHeight()
    if (height > maxHeight) maxHeight = height
  })

  $slides.css('height', maxHeight + 'px')
}

// USP Slider
function initUspSlider() {
  const $slider = $('.usp-slider')

  if ($(window).width() < 1024 && !$slider.hasClass('slick-initialized')) {
    $slider.slick({
      dots: true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            centerPadding: '20px',
          },
        },
      ],
    })

    // Check for screen resizing
    setTimeout(normalizeUspSlideHeights, 100)
  } else if ($(window).width() >= 1024 && $slider.hasClass('slick-initialized')) { // Destroys the slider at high enough screen size
    $slider.slick('unslick')
  }
}

// Resizing function for the Collection Slides. Adjusts everything so that the height across all slides is the same.
function normalizeCollectionSlideHeights() {
  const $slides = $('.collection-slider .card-collection')

  let maxHeight = 0

  $slides.css('height', 'auto')

  $slides.each(function () {
    const height = $(this).outerHeight()
    if (height > maxHeight) maxHeight = height
  })

  $slides.css('height', maxHeight + 'px')
}

// Collections Slider
function initCollectionSlider() {
  const $slider = $('.collection-slider')

  if ($(window).width() < 1024 && !$slider.hasClass('slick-initialized')) {
    $slider.slick({
      dots: true,
      arrows: false,
      autoplay: false,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            centerPadding: '20px',
          },
        },
      ],
    })

    // Check for screen resizing
    setTimeout(normalizeCollectionSlideHeights, 100)
  } else if ($(window).width() >= 1024 && $slider.hasClass('slick-initialized')) { // Destroys the slider at high enough screen size
    $slider.slick('unslick')
  }
}

$(document).ready(function () {
  initUspSlider()
  normalizeUspSlideHeights()
  normalizeCollectionSlideHeights

  initCollectionSlider()
})

$(window).on('resize', function () {
  initUspSlider()
  normalizeUspSlideHeights()
  normalizeCollectionSlideHeights

  initCollectionSlider()
})
